// extracted by mini-css-extract-plugin
export var active = "_in-2";
export var recordingDot = "_in-1";
export var recordingIndicator = "_in-0";